import { getDeviceInfo } from "../helpers/commonHelpers";
import { getPhoneNumberFromLs, parseMsisdn, clearIsAutoLogin } from "../utils/commonUtils";
import { callGetSecureSmsToken, callSendOtp } from "../Redux/slices/loginSlice";
import { store } from "../Redux";
import { sendGA4Event } from "../services/ga4";
import { callCheckGSMBalance } from "../Redux/slices/balanceSlice";
import { createCheckGSMBalancePayload } from '../features/BalanceV2/config/balancePayloads'
import { SOME_ERR } from "../data/constants";

import { IGetLobPayload, IGetLobPayloadV2 } from "../config/commonInterfaces";
import { headings } from "../data/constants";
import { logAnalyticEvents } from "./eventHelper";
import { EVENT_TYPES, LOGIN_EVENT_TYPES, LOGIN_PHASE, LOGIN_TYPES } from "../data/globals";
import { eventCategory, LOGIN_REASON_CODE_LIST, LOGIN_REASON_DESC_LIST } from "../data/events";

/**
 * Create request payload for line of business api
 * Accepts request data, success & error flow callback
 * @deprecated
 */
export const createGetLOBPayload = (phoneNumer: string, callback: IGetLobPayload["callback"], errorCallback: IGetLobPayload["errorCallback"],hideLoader:boolean=false): IGetLobPayload => {
  return {
    data: {
      siNumber: parseMsisdn(phoneNumer),
      flowType: ""
    },
    callback,
    errorCallback,
    hideLoader
  };
}

export const createGetLOBPayloadV2 = (phoneNumer: string, callbackV2: IGetLobPayloadV2["callbackV2"], errorCallback: IGetLobPayloadV2["errorCallback"]): IGetLobPayloadV2 => {
  return {
    data: {
      siNumber: parseMsisdn(phoneNumer),
      flowType: ""
    },
    callbackV2,
    errorCallback
  };
}

export const createSendOtpPayload = (phoneNumber: string, callback: any, hideLoader?: boolean) => {
  return {
    data: {
      username: phoneNumber,
      communicationType: headings.SMS
    },
    callback,
    hideLoader,
  };
}

export const createResendOtpPayload = (otpId: string, phoneNumber: string, callback: any) => {
  return {
    data: {
      username: phoneNumber,
      communicationType: headings.SMS
    },
    callback
  }
}

export const createVerifyOtpPayload = (otp: string, otpId: string, phoneNumber: string, callback: any) => {
  return {
    data: {
      otp: otp,
      otpId: otpId,
      username: phoneNumber
    },
    callback
  }
};

export const isLoginMsisdnsLenInLimit = (loginMsisdn: string, msisdnLength: number) => {
  const zeroIsPrefixed = loginMsisdn.startsWith("0");
  return (zeroIsPrefixed && loginMsisdn.length <= +msisdnLength + 1) || (!zeroIsPrefixed && loginMsisdn.length <= +msisdnLength);
}

export const isLoginMsisdnsLenComplete = (loginMsisdn: string, msisdnLength: number) => {
  const zeroIsPrefixed = loginMsisdn.startsWith("0");
  return (zeroIsPrefixed && loginMsisdn.length === +msisdnLength + 1) || (!zeroIsPrefixed && loginMsisdn.length === +msisdnLength);

}

export const isSecureSmsSupported = (secureSmsNonSupportedBrowsers: any) => {
  let flag = false;
  const device = getDeviceInfo();
  const ind = secureSmsNonSupportedBrowsers && secureSmsNonSupportedBrowsers.findIndex((item: any) => ((item?.browserName.toLowerCase() === device?.BrowserName.toLowerCase()) && (item?.osName.toLowerCase() === device?.OSName.toLowerCase())));
  if (ind === -1) flag = true;
  return flag;
}

export function sendOtp(rawMsisdn: any, setApiErrorMsg: any, setDoShowOTPScreen: any, setOTPId: any, setIsOtpSending?: any, hideLoader?: boolean) {
  store.dispatch(callSendOtp(createSendOtpPayload(parseMsisdn(rawMsisdn), (response: any) => {
    if (response.statusCode === 200) {
      setApiErrorMsg("");
      setDoShowOTPScreen(true);
      setOTPId(response?.result?.otpId || "");
      sendGA4Event({ category: "login", action: "login_otp_otpsent" });
      setIsOtpSending(false);
      clearIsAutoLogin()
    }
    else if (response?.message) {
      setApiErrorMsg(response.message || SOME_ERR);
      sendGA4Event({ category: "login", action: "otp_sent_failed" });
      setIsOtpSending(false)
      logAnalyticEvents({ category: eventCategory.LOGIN, action: LOGIN_EVENT_TYPES.LOGIN_FAILURE, data: { loginType: LOGIN_TYPES.OTP }, status: LOGIN_PHASE.FAILED, target: [EVENT_TYPES.TCR], reason: LOGIN_REASON_CODE_LIST.SEND_OTP_FAIL, errorMessage: LOGIN_REASON_DESC_LIST.OTP_SEND_FAILED })
    }
  }, hideLoader)));
}

export function getSecureSMSToken(rawMsisdn: string, setSecureToken: any, setShorthand: any, setShowSecureSms: any, setSecureSmsErrCode: any, setSecureSmsError?: (arg: string) => void) {
  const deviceInfo = getDeviceInfo();
  let payload = {
    data: {
      msisdn: rawMsisdn,
      osystem: deviceInfo.OSName,
      browser: deviceInfo.BrowserName
    },
    callback: function (response: any) {
      if (response.statusCode === 200 && !!response?.result?.encryptedToken && !!response?.result?.shortCode) {
        setSecureToken(response.result.encryptedToken);
        setShorthand(response.result.shortCode);
        setShowSecureSms(true);
        setSecureSmsError?.("");
        clearIsAutoLogin();
      } else {
        setSecureSmsErrCode(response?.statusCode);
        setShowSecureSms(false);
        setSecureSmsError?.(response.message || SOME_ERR);
        logAnalyticEvents({ category: eventCategory.LOGIN, action: LOGIN_EVENT_TYPES.LOGIN_FAILURE, data: { loginType: LOGIN_TYPES.SECURE_SMS }, status: LOGIN_PHASE.FAILED, target: [EVENT_TYPES.TCR], reason: LOGIN_REASON_CODE_LIST.FETCH_SECURE_SMS_TOKEN_FAILED, errorMessage: response.message || SOME_ERR });
      }
    }
  };
  store.dispatch(callGetSecureSmsToken(payload));
}

export function fetchGSMBalances(payload: any, hideLoader?: boolean) {
  const balance = store.getState()?.balance?.balance;
  if (!balance.isFetchingGSMBalance)
    store.dispatch(callCheckGSMBalance(createCheckGSMBalancePayload({ msisdn: getPhoneNumberFromLs(), ...payload }, hideLoader)));
}